import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { APIService } from 'src/app/core/api/general.service';
import { ItineraryService } from '../../search-result/services/itinerary.service';
import { TicketHistoryService } from '../../search-result/services/ticket-history.service';
import { SearchForm } from 'src/app/core/models/itinerary.model';
import { LayoutService } from 'src/app/layout/services/layout.service';
import { OptionType } from 'src/app/core/enums/enums';

function loadTicketHistory(
  form: SearchForm,
  api: APIService,
  layoutService: LayoutService,
  ticketHistoryService: TicketHistoryService,
  itineraryService: ItineraryService
) {
  return api.getTicketHistory(form).pipe(
    map((response) => {
      layoutService.dispatchChangeBreadcrumb(form.pnr, OptionType.TicketHistory);
      ticketHistoryService.dispatchLoadTicketHistorySuccess(response);
      return !!response;
    }),
    catchError((response) => {
      itineraryService.dispatchGenericError(response);
      itineraryService.navigateToWithParams('itinerary/info');
      return of(false);
    })
  );
}

export const TicketHistoryGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const api = inject(APIService);
  const itineraryService = inject(ItineraryService);
  const ticketHistoryService = inject(TicketHistoryService);
  const layoutService = inject(LayoutService);

  return loadTicketHistory(
    { ...route.queryParams } as SearchForm,
    api,
    layoutService,
    ticketHistoryService,
    itineraryService
  );
};
